module.exports = __webpack_public_path__ + "static/media/circleconcretesection.da93e103.svg";